export const REPORT_FILTER_ALL_VALUE = "__ALL__";

const allOption = { key: "all", text: "Todos", value: REPORT_FILTER_ALL_VALUE };

export const orderMarketplaceOptions = [
  allOption,
  { key: "mercado_libre", text: "Mercado Libre", value: "mercado_libre" },
  { key: "tienda_nube", text: "Tienda Nube", value: "tienda_nube" },
];

export const orderStatusOptions = [
  allOption,
  { key: "PENDING", text: "PENDING", value: "PENDING" },
  { key: "CONFIRMED", text: "CONFIRMED", value: "CONFIRMED" },
  { key: "SHIPPED", text: "SHIPPED", value: "SHIPPED" },
  { key: "DELIVERED", text: "DELIVERED", value: "DELIVERED" },
  { key: "CANCELLED", text: "CANCELLED", value: "CANCELLED" },
];

export const movementSourceTypeOptions = [
  allOption,
  { key: "WEBHOOK", text: "Webhook", value: "WEBHOOK" },
  { key: "USER", text: "Usuario", value: "USER" },
  { key: "SYNC", text: "Sistema", value: "SYNC" },
];

export const movementChannelOptions = [
  allOption,
  { key: "MERCADO_LIBRE", text: "Mercado Libre", value: "MERCADO_LIBRE" },
  { key: "TIENDA_NUBE", text: "Tienda Nube", value: "TIENDA_NUBE" },
  { key: "MERCURYCOM", text: "MercuryCom", value: "MERCURYCOM" },
];

export const movementActorTypeOptions = [
  allOption,
  { key: "USER", text: "Usuario", value: "USER" },
  {
    key: "MARKETPLACE_ACCOUNT",
    text: "Cuenta marketplace",
    value: "MARKETPLACE_ACCOUNT",
  },
  { key: "SYSTEM", text: "Sistema", value: "SYSTEM" },
];

export const movementTypeOptions = [
  allOption,
  {
    key: "MANUAL_ADJUSTMENT",
    text: "Ajuste manual",
    value: "MANUAL_ADJUSTMENT",
  },
  { key: "SALE", text: "Venta", value: "SALE" },
  {
    key: "SYNC_ADJUSTMENT",
    text: "Sincronización de stock",
    value: "SYNC_ADJUSTMENT",
  },
  {
    key: "INITIAL_IMPORT",
    text: "Importación inicial",
    value: "INITIAL_IMPORT",
  },
  { key: "ORDER_CANCEL", text: "Cancelación de orden", value: "ORDER_CANCEL" },
];

export const movementStatusOptions = [
  allOption,
  { key: "SUCCESS", text: "Sin errores", value: "SUCCESS" },
  { key: "ERROR", text: "Con errores", value: "ERROR" },
];

export const orderInitialFilters = {
  from: "",
  to: "",
  marketplace: "",
  status: "",
  marketplaceId: "",
  buyer: "",
  sku: "",
};

export const movementInitialFilters = {
  from: "",
  to: "",
  sku: "",
  sourceType: "",
  sourceChannel: "",
  actorType: "",
  movementType: "",
  movementStatus: "",
};

export const orderExportFields = [
  { name: "from", label: "Desde", type: "datetime-local" },
  { name: "to", label: "Hasta", type: "datetime-local" },
  { name: "sku", label: "SKU", placeholder: "SKU completo o parcial" },
  {
    name: "marketplace",
    label: "Canal",
    type: "select",
    options: orderMarketplaceOptions,
  },
  {
    name: "status",
    label: "Estado",
    type: "select",
    options: orderStatusOptions,
  },
  { name: "marketplaceId", label: "ID Marketplace" },
  { name: "buyer", label: "Comprador" },
];

export const movementExportFields = [
  { name: "from", label: "Desde", type: "datetime-local" },
  { name: "to", label: "Hasta", type: "datetime-local" },
  { name: "sku", label: "SKU", placeholder: "Mínimo 3 caracteres" },
  {
    name: "sourceType",
    label: "Origen",
    type: "select",
    options: movementSourceTypeOptions,
  },
  {
    name: "sourceChannel",
    label: "Canal",
    type: "select",
    options: movementChannelOptions,
  },
  {
    name: "actorType",
    label: "Actor",
    type: "select",
    options: movementActorTypeOptions,
  },
  {
    name: "movementType",
    label: "Tipo de movimiento",
    type: "select",
    options: movementTypeOptions,
  },
  {
    name: "movementStatus",
    label: "Estado",
    type: "select",
    options: movementStatusOptions,
  },
];

const trimFields = (filters, fields) =>
  fields.reduce(
    (result, field) => ({
      ...result,
      [field]: String(result[field] || "").trim(),
    }),
    { ...filters },
  );

const normalizeAllSelection = (value) =>
  value === REPORT_FILTER_ALL_VALUE ? "" : value;

export const resolveReportSelectValue = (value, options = []) => {
  if (value !== undefined && value !== null && String(value) !== "") {
    return value;
  }
  return options.some((option) => option.value === REPORT_FILTER_ALL_VALUE)
    ? REPORT_FILTER_ALL_VALUE
    : "";
};

export const normalizeOrderReportFilters = (filters) => {
  const normalized = trimFields(filters, ["marketplaceId", "buyer", "sku"]);
  return {
    ...normalized,
    marketplace: normalizeAllSelection(normalized.marketplace),
    status: normalizeAllSelection(normalized.status),
  };
};

export const normalizeMovementReportFilters = (filters) => {
  const normalized = trimFields(filters, ["sku"]);
  const movementStatus = normalizeAllSelection(normalized.movementStatus);
  return {
    ...normalized,
    sku: normalized.sku.length >= 3 ? normalized.sku : "",
    sourceType: normalizeAllSelection(normalized.sourceType),
    sourceChannel: normalizeAllSelection(normalized.sourceChannel),
    actorType: normalizeAllSelection(normalized.actorType),
    movementType: movementStatus
      ? "SYNC_ADJUSTMENT"
      : normalizeAllSelection(normalized.movementType),
    movementStatus,
  };
};

export const validateReportFilters = (
  filters,
  { minimumSkuLength = 1 } = {},
) => {
  const from = filters.from ? new Date(filters.from) : null;
  const to = filters.to ? new Date(filters.to) : null;
  if (from && Number.isNaN(from.getTime()))
    return "La fecha Desde no es valida.";
  if (to && Number.isNaN(to.getTime())) return "La fecha Hasta no es valida.";
  if (from && to && from.getTime() > to.getTime())
    return "Desde debe ser anterior o igual a Hasta.";
  if (from && to && (to.getTime() - from.getTime()) / 86400000 > 366) {
    return "El rango maximo de exportacion es de 366 dias.";
  }
  const sku = String(filters.sku || "").trim();
  if (sku && sku.length < minimumSkuLength) {
    return `El SKU debe tener al menos ${minimumSkuLength} caracteres.`;
  }
  return "";
};

export const describeReportFilters = (filters, fields) => {
  const descriptions = fields
    .map((field) => {
      const value = String(filters[field.name] || "").trim();
      if (!value || value === REPORT_FILTER_ALL_VALUE) return "";
      const selected = field.options?.find((option) => option.value === value);
      return `${field.label}: ${selected?.text || value}`;
    })
    .filter(Boolean);
  return descriptions.length
    ? descriptions.join(" · ")
    : "Sin filtros: se exportaran todos los registros permitidos.";
};
